<template>
  <div>
    <custom-dialog width="640px" v-if="show" :visible="show" title="快捷预约" @close="close">
      <div slot="content" class="registerForm-warp">
        <el-radio-group v-model="type" @input="typeChange">
          <el-radio-button label="0">已购买预约</el-radio-button>
          <el-radio-button label="1">未购买预约</el-radio-button>
          <el-radio-button label="2">三方客户预约</el-radio-button>
        </el-radio-group>
        <el-form class="patient-warp" inline :model="form">
          <el-form-item prop="patientName" class="mr4">
            <el-select ref="patientRef" :popper-append-to-body="false" popper-class="customSelectStyle"
              class="name-select" v-model="form.patientName" placeholder="患者姓名" filterable remote reserve-keyword
              :remote-method="getPatientInfoByName" value-key="patientId" @change="selectPatient">
              <el-option v-for="item in patientList" :key="item.patientId" :value="item" class="display-f">
                <span style="width: 96px; display:inline-block;" class="mr12 text-overflow">{{
                  item.patientName }}</span>
                <span class="mr24">{{ item.sex == '0' ? '男' : '女' }}</span>
                <span style="width: 72px; display:inline-block" class="mr24">{{ item.age }}岁{{ item.ageMth
                }}月</span>
                <span style="width: 112px; display:inline-block">{{ item.phone }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="sex" class="mr4">
            <el-select disabled :popper-append-to-body="false" popper-class="customSelectStyle" class="sex-select"
              v-model="form.sex">
              <el-option v-for="item in [{ label: '男', value: '0' }, { label: '女', value: '1' }]" :key="item.value"
                :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item prop="year" class="mr4">
            <el-input disabled ref="year" class="year-input" v-model.number="form.year" @blur="computeBirthday">
            </el-input>
            <div class="append">岁</div>
          </el-form-item>
          <el-form-item prop="month" class="mr4">
            <el-input disabled ref="month" class="year-input" v-model.number="form.month" @blur="computeBirthday">
            </el-input>
            <div class="append">月</div>
          </el-form-item>
          <el-form-item prop="phone" class="mr4">
            <el-select :popper-append-to-body="false" popper-class="customSelectStyle" class="phone-select"
              v-model="form.phone" placeholder="患者手机号" filterable remote reserve-keyword
              :remote-method="getPatientInfoByPhone" value-key="patientId" @change="selectPatient">
              <el-option v-for="item in patientList" :key="item.patientId" :value="item">
                <span style="width: 96px; display:inline-block" class="mr12">{{ item.patientName }}</span>
                <span class="mr24">{{ item.sex == '0' ? '男' : '女' }}</span>
                <span style="width: 72px; display:inline-block" class="mr24">{{ item.age }}岁{{ item.ageMth
                }}月</span>
                <span style="width: 112px; display:inline-block">{{ item.phone }}</span>
              </el-option>
            </el-select>
            <div class="close-icon iconfont icon-cha" @click="clearPatient" v-if="form.patientId"></div>
          </el-form-item>
          <div class="add-btn" @click="handleAddPatient" v-if="type == 1 || type == 2">
            <span class="iconfont icon-xinzenghuanz icon-1F2329"></span>
          </div>
        </el-form>
        <div class="action-warp">
          <el-empty v-if="!form.patientId || (orderList.length == 0 && type == '0')" :image="imgArr.a6"
            :description="form.patientId ? '暂无可约订单' : '请先查询患者信息'"></el-empty>
          <div v-else>
            <div v-if="type == '0'">
              <div class="recipe-list">
                <div class="recipe-item" :class="{ 'recipe-item-active': orderId == item.orderId }"
                  v-for="(item, index) in orderList" :key="index" @click="selectOrder(item.orderId)">
                  <div class="recipe-item-top">
                    <img :src="imgArr.a5" class="recipe-item-img">
                    <div>
                      <div class="size16 color1a1a font600">{{ item.diagnoseNames }}</div>
                      <div class="size12 color667 mt8">来自{{ item.doctorName }}医生的处方</div>
                    </div>
                  </div>
                  <div class="recipe-item-project">
                    <span class="font600">项目：</span>
                    <span>{{ item.productText }}</span>
                  </div>
                  <div class="recipe-item-time">收费时间：{{ computeDate(item.collectFeeDateTime) }}</div>
                </div>
              </div>
              <el-form ref="form" class="dialog_form" :model="form" :rules="rules" label-width="100px">
                <el-form-item label="预约项目：" prop="physioIds">
                  <el-checkbox-group class="form_checkbox_group" v-model="form.physioIds" @change="productCheckbox">
                    <el-checkbox v-for="item in productList" :key="item.physioId" class="form_checkbox"
                      :label="item.physioId">{{ item.physioName }}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="执行人：" prop="doctorId">
                  <el-select class="form_input" v-model="form.doctorId" filterable placeholder="请选择"
                    @change="doctorChange">
                    <el-option v-for="doctor in doctorOptions" :label="doctor.doctorName"
                      :value="doctor.doctorId"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预约日期：" prop="reservationDateTime">
                  <el-date-picker
                    class="form_input"
                    v-model="form.reservationDateTime"
                    type="date"
                    :picker-options="pickerOptions"
                    :editable="false"
                    :disabled="[null, undefined, ''].includes(form.doctorId)"
                    placeholder="选择预约日期"
                    value-format="yyyy-MM-dd"
                    popper-class="physio_reservation_date_picker"
                    @change="reservationDateChange">
                  </el-date-picker>
                </el-form-item>
                <div
                  v-if="form.physioIds.length > 0 && ![null, undefined, ''].includes(form.doctorId) && ![null, undefined, ''].includes(form.reservationDateTime)">
                  <el-form-item class="form_item_times" label="预约时段：" required>
                    <div v-if="schedulingList.length === 0">暂无可选排班</div>
                  </el-form-item>
                  <div class="scheduling">
                    <div v-for="classes in schedulingList" :key="classes.timeType" class="scheduling_classes">
                      <div class="scheduling_classes_name">{{ classes.timeTypeName }}</div>
                      <div class="scheduling_list">
                        <div v-for="scheduling in classes.list" :key="scheduling.vId"
                          :class="{ scheduling_item: true, active: scheduling.vId === form.schedulingItemVId, disabled: scheduling.disabled }"
                          @click="selectScheduling(scheduling)">
                          <div class="scheduling_item_time">{{ scheduling.appointmentStartTimeText }}-{{
                            scheduling.appointmentEndTimeText }}</div>
                          <div class="scheduling_item_status">{{ scheduling.describe }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-form>
            </div>
            <!-- 未购买预约 -->
            <div v-if="type == '1'">
              <el-form ref="form" class="dialog_form" :model="form" :rules="rules" label-width="100px">
                <el-form-item label="预约项目：" prop="spuIds">
                  <el-select class="form_input" v-model="form.spuIds" multiple filterable remote
                    :remote-method="remoteProcutionList" placeholder="请选择" clearable @change="productChange">
                    <el-option v-for="item in productList" :key="item.spuId" :label="item.physioName"
                      :value="item.spuId"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预约日期：" prop="reservationDateTime">
                  <el-date-picker class="form_input" v-model="form.reservationDateTime" type="date"
                    :picker-options="pickerOptions" placeholder="选择日期时间" value-format="yyyy-MM-dd"
                    @change="reservationDateChange">
                  </el-date-picker>
                </el-form-item>
                <div v-if="form.spuIds.length > 0 && ![null, undefined, ''].includes(form.reservationDateTime)">
                  <el-form-item class="form_item_doctor" label="执行人：" required>
                    <div v-if="doctorList.length === 0">暂无可选执行人</div>
                  </el-form-item>
                  <div class="doctor_list">
                    <div v-for="doctor in doctorList" :key="doctor.doctorId"
                      :class="{ doctor_item: true, active: doctor.doctorId === form.doctorId }"
                      @click="selectDoctor(doctor.doctorId)">
                      <div class="doctor_item_portrait">
                        <img class="doctor_item_portrait_img" :src="doctor.doctorImgAddr">
                      </div>
                      <div class="doctor_item_name">{{ doctor.doctorName }}</div>
                    </div>
                  </div>
                </div>
                <div v-if="![null, undefined, ''].includes(form.doctorId)" class="scheduling_section">
                  <el-form-item class="form_item_times" label="预约时段：" required>
                    <div v-if="schedulingList.length === 0">暂无可选排班</div>
                  </el-form-item>
                  <div class="scheduling">
                    <div v-for="classes in schedulingList" :key="classes.timeType" class="scheduling_classes">
                      <div class="scheduling_classes_name">{{ classes.timeTypeName }}</div>
                      <div class="scheduling_list">
                        <div v-for="scheduling in classes.list" :key="scheduling.vId"
                          :class="{ scheduling_item: true, active: scheduling.vId === form.schedulingItemVId, disabled: scheduling.disabled }"
                          @click="selectScheduling(scheduling)">
                          <div class="scheduling_item_time">{{ scheduling.appointmentStartTimeText }}-{{
                            scheduling.appointmentEndTimeText }}</div>
                          <div class="scheduling_item_status">{{ scheduling.describe }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-form>
            </div>
            <!-- 三方客户预约 -->
            <div v-if="type == '2'">
              <el-form ref="form" class="dialog_form" :model="form" :rules="rules" label-width="100px">
                <el-form-item label="预约项目：" prop="spuIds">
                  <el-select class="form_input" v-model="form.spuIds" multiple filterable remote
                    :remote-method="remoteProcutionList" placeholder="请选择" clearable @change="productChange">
                    <el-option v-for="item in productList" :key="item.spuId" :label="item.physioName"
                      :value="item.spuId"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="预约日期：" prop="reservationDateTime">
                  <el-date-picker class="form_input" v-model="form.reservationDateTime" type="date"
                    :picker-options="pickerOptions" placeholder="选择日期时间" value-format="yyyy-MM-dd"
                    @change="reservationDateChange">
                  </el-date-picker>
                </el-form-item>
                <div v-if="form.spuIds.length > 0 && ![null, undefined, ''].includes(form.reservationDateTime)">
                  <el-form-item class="form_item_doctor" label="执行人：" required>
                    <div v-if="doctorList.length === 0">暂无可选执行人</div>
                  </el-form-item>
                  <div class="doctor_list">
                    <div v-for="doctor in doctorList" :key="doctor.doctorId"
                      :class="{ doctor_item: true, active: doctor.doctorId === form.doctorId }"
                      @click="selectDoctor(doctor.doctorId)">
                      <div class="doctor_item_portrait">
                        <img class="doctor_item_portrait_img" :src="doctor.doctorImgAddr">
                      </div>
                      <div class="doctor_item_name">{{ doctor.doctorName }}</div>
                    </div>
                  </div>
                </div>
                <div v-if="![null, undefined, ''].includes(form.doctorId)" class="scheduling_section">
                  <el-form-item class="form_item_times" label="预约时段：" required>
                    <div v-if="schedulingList.length === 0">暂无可选排班</div>
                  </el-form-item>
                  <div class="scheduling">
                    <div v-for="classes in schedulingList" :key="classes.timeType" class="scheduling_classes">
                      <div class="scheduling_classes_name">{{ classes.timeTypeName }}</div>
                      <div class="scheduling_list">
                        <div v-for="scheduling in classes.list" :key="scheduling.vId"
                          :class="{ scheduling_item: true, active: scheduling.vId === form.schedulingItemVId, disabled: scheduling.disabled }"
                          @click="selectScheduling(scheduling)">
                          <div class="scheduling_item_time">{{ scheduling.appointmentStartTimeText }}-{{
                            scheduling.appointmentEndTimeText }}</div>
                          <div class="scheduling_item_status">{{ scheduling.describe }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </div>
        <div class="dialog_footer">
          <el-button class="dialog_cancel" @click="close">取消</el-button>
          <el-button class="dialog_confirm" type="primary" @click="submit">确定</el-button>
        </div>
      </div>
      <div slot="footer"></div>
    </custom-dialog>
    <addPatient ref="addPatient" v-if="patientMap.addPatientDialog" :visibleObj="patientMap"
      @addPatientComfirm="addPatientComfirm" @close="addPatientClose">
    </addPatient>
    <CustomDialog title="确认预约信息" width="450px" v-if="confirmOrderMap.show" :visible="confirmOrderMap.show" @close="confirmOrderMap.show = false">
      <div slot="content" class="confirmDialog">
        <div class="mb8">患者信息：{{ form.patientName }}/{{ form.sex == '0' ? '男' : '女' }}/{{ form.year }}岁</div>
        <div class="mb8">执行医师：<span class="color189">{{ form.doctorName }}</span></div>
        <div class="mb8">预约时间：{{ form.reservationDateTime }} <span class="color189">{{ form.appointmentStartTimeText }}-{{ form.appointmentEndTimeText }}</span></div>
        <div class="mb8">执行项目：{{ productSelectList.map(v => { return v.physioName }).join('、') }}</div>
        <div v-if="type == '1' || type == '2'" class="mb8">预计时长：{{ form.totalServerTime }}</div>
      </div>
      <div slot="footer" class="confirmOrder_footer">
        <el-button class="dialog_cancel" @click="confirmOrderMap.show = false">取消</el-button>
        <el-button v-if="type == '2'" class="dialog_redeem" @click="confirmAndRedeem">预约并核销</el-button>
        <el-button class="dialog_confirm" type="primary" @click="confirmOrder">确定</el-button>
      </div>
    </CustomDialog>
  </div>
</template>


<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import { patientInfom } from "@/api/patient"; // 病人列表请求
import { isNull, isEmptyArray, debounce } from '@/utils/validateBase'
import addPatient from '@/components/addPatient'

import { getReservationScheduling, postPhysioReservation, getPhysioProcutions, getPhysioTrilateralReservationScheduling, postPhysioTrilateralReservation, queryReservationAppletCard } from '@/api/physio.js'
import { imgArr } from '@/assets/images/img';

import req from '@/utils/request'

const timeTypeMap = {
  '1': '上午',
  '2': '中午',
  '3': '下午',
  '4': '晚上'
}

export default {
  name: 'RegisterDialog',
  components: {
    CustomDialog, addPatient
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      imgArr:imgArr,
      type: '0',
      patientList: [],
      productSelectList: [],
      form: {
        sex: '0',
        year: "",//岁
        month: '',//月份
        phone: '',
        physioIds: [],
        doctorId: '',
        reservationDateTime: '',
        schedulingItemVId: '',
        patientId: '',
        patientName: '',
        spuIds: [],
        appointmentStartTimeText:'',
        appointmentEndTimeText:''
      },
      orderId: '',
      productList: [],
      doctorOptions: [],
      physioSchedulingDayStatusList: [],
      pickerOptions: {
        disabledDate: (time) => {
          const minDate = new Date()
          let maxDate = new Date()
          maxDate.setDate(1)
          maxDate.setDate(64)
          maxDate.setDate(0)

          const startDate = minDate.Format('yyyy-MM-dd')
          const endDate = maxDate.Format('yyyy-MM-dd')

          if (time.Format('yyyy-MM-dd') < startDate || time.Format('yyyy-MM-dd') > endDate) {
            return true
          } else {
            const day = time.Format('yyyy-MM-dd')
            const status = this.physioSchedulingDayStatusList.find(v => v.date === day)
            if (status) {
              return true
            } else {
              return false
            }
          }
        },
        cellClassName: this.setReservationDateCellClass
      },
      noProjectPickerOptions: {
        disabledDate(time) {
          return time.Format('yyyy-MM-dd') < new Date().Format('yyyy-MM-dd')
        }
      },
      sourceSchedulingList: [],
      schedulingList: [],
      rules: {
        spuIds: [{ required: true, message: '请选择预约项目', trigger: 'change' }],
        physioIds: [{ required: true, message: '请选择预约项目', trigger: 'change' }],
        doctorId: [{ required: true, message: '请选择执行人', trigger: 'change' }],
        reservationDateTime: [{ required: true, message: '请选择预约时间', trigger: 'change' }]

      },
      doctorList: [],
      orderList: [],
      patientMap: {
        addPatientDialog: false
      },
      confirmOrderMap: {
        show: false
      }
    }
  },
  computed:{
    computeDate(){
      return function(val,format='YYYY-MM-DD HH:mm:ss'){
        return this.$moment(val).format(format)
      }
    }
  },
  created() {
    this.$getDoctorOptions()
  },
  methods: {
    close() {
      this.$emit('close')
    },
    // 根据姓名获取患者列表
    getPatientInfoByName: debounce(async function (name) {
      let { code, data } = await patientInfom({ name })
      this.patientList = [];
      if (code == 200) {
        data.forEach(item => { this.$computeAge(item.birthday, item) })
        this.patientList = data;
      }
    }, 300),
    getPatientInfoByPhone: debounce(async function (phone) {
      let { code, data } = await patientInfom({ phone })
      this.patientList = [];
      if (code == 200) {
        data.forEach(item => { this.$computeAge(item.birthday, item) })
        this.patientList = data;
      }
    }, 300),
    selectPatient(item) {
      let { patientId, patientName, phone, age, ageMth, sex, birthday } = item
      this.form = {
        ...this.form,
        patientId, patientName, phone, year: age, month: ageMth, sex, birthday
      }
      this.patientList = []
      if (this.type == '0') {
        this.queryReservationAppletCard()
      }
    },
    // 计算生日
    computeBirthday() {
      this.form.birthday = this.$computeBirthday(this.form.year, this.form.month);
    },
    clearPatient() {
      this.typeChange()
    },
    editPatient() {
      this.patientDialogTitle = '修改患者'
      this.patientMap.addPatientDialog = true;
    },
    handleAddPatient() {
      this.addPatientType = 'add'
      this.patientMap.addPatientDialog = true;
    },
    productChange(selectList) {
      let list = []
      if (selectList) {
        selectList.forEach(v1 => {
          const hasProduct = this.productSelectList.find(v2 => v2.spuId === v1)
          if (hasProduct) {
            list.push(hasProduct)
          } else {
            const product = this.productList.find(v2 => v2.spuId === v1)
            list.push({
              spuId: v1,
              physioId: product.physioId,
              physioName: product.physioName
            })
          }
        })
      }
      this.productSelectList = list
      this.doctorList = []
      this.form.doctorId = ''
      this.form.doctorName = ''
      this.schedulingList = []
      this.form.schedulingItemVId = ''
      this.getDoctorList()
    },
    productCheckbox(selectList) {
      let list = []
      if (selectList) {
        selectList.forEach(v1 => {
          const hasProduct = this.productSelectList.find(v2 => v2.physioId === v1)
          if (hasProduct) {
            list.push(hasProduct)
          } else {
            const product = this.productList.find(v2 => v2.physioId === v1)
            list.push({
              spuId: v1,
              physioId: product.physioId,
              physioName: product.physioName
            })
          }
        })
      }
      this.productSelectList = list
      this.sourceSchedulingList = []
      this.schedulingList = []
      this.form.schedulingItemVId = ''
      this.getScheduling()
    },
    doctorChange(val) {
      this.form.doctorName = this.doctorOptions.find(item => item.doctorId == val).doctorName
      this.sourceSchedulingList = []
      this.schedulingList = []
      this.form.schedulingItemVId = ''

      this.form.reservationDateTime = ''
      this.getPhysioSchedulingDayStatus()
    },
    async getScheduling() {
      if (this.form.physioIds.length > 0 && ![null, undefined, ''].includes(this.form.doctorId) && ![null, undefined, ''].includes(this.form.reservationDateTime)) {
        const res = await getReservationScheduling({
          deptId: sessionStorage.getItem('deptId'),
          orderId: this.orderId,
          physioIds: this.form.physioIds,
          doctorId: this.form.doctorId,
          reservationDateTime: this.form.reservationDateTime
        })
        if (res.code === 200) {
          const source = res.data.map(v => {
            v['vId'] = this.generateUUID()
            v['date'] = new Date(v.appointmentStartDateTime).Format('yyyy-MM-dd')
            v['appointmentStartDateTime'] = new Date(v.appointmentStartDateTime).Format('yyyy-MM-dd hh:mm:ss')
            v['appointmentEndDateTime'] = new Date(v.appointmentEndDateTime).Format('yyyy-MM-dd hh:mm:ss')
            v['appointmentStartTimeText'] = new Date(v.appointmentStartDateTime).Format('hh:mm')
            v['appointmentEndTimeText'] = new Date(v.appointmentEndDateTime).Format('hh:mm')
            v['timeTypeName'] = timeTypeMap[v.timeType]

            const bookedRecord = v.reservationNoticeBoardTimes.find(record => {
              return (this.form.patientId === record.patientId) && (this.orderId === record.orderId) && (new Date(record.reservationStartTime).Format('yyyy-MM-dd hh:mm:ss') === v.appointmentStartDateTime)
            })

            v['bookedStatus'] = !['', undefined, null].includes(bookedRecord)
            v['releaseStatus'] = new Date(v.releaseTime).getTime() < new Date().getTime()
            v['disabled'] = false
            v['describe'] = '可约'
            switch (true) {
              case v.status === '1':
                v.describe = '停诊'
                v.disabled = true
                break
              case !v.releaseStatus:
                v.describe = '未放号'
                v.disabled = true
                break
              case new Date(v.appointmentEndDateTime).getTime() < new Date().getTime():
                v.describe = '完诊'
                v.disabled = true
                break
              case v.bookedStatus:
                v.describe = '已约'
                v.disabled = true
                break
              case !v.useReservation:
                v.describe = '约满'
                v.disabled = true
                break
            }
            return v
          })

          this.sourceSchedulingList = source

          this.schedulingList = source.reduce((res, cur) => {
            const resType = res.find(v => v.timeType === cur.timeType)
            if (resType) {
              resType.list.push(cur)
            } else {
              res.push({
                timeType: cur.timeType,
                timeTypeName: cur.timeTypeName,
                list: [cur]
              })
            }
            return res
          }, [])
        }
      }
    },
    setReservationDateCellClass (date) {
      const day = new Date(date).Format('yyyy-MM-dd')
      const status = this.physioSchedulingDayStatusList.find(v => v.date === day)
      if (status) {
        return `date-picker_reservation_cell_${status.status}`
      }
    },
    async getPhysioSchedulingDayStatus () {
      const minDate = new Date()
      let maxDate = new Date()
      maxDate.setDate(1)
      maxDate.setDate(64)
      maxDate.setDate(0)

      const dayNum = (Math.ceil((maxDate - minDate) / (1000 * 60 * 60 * 24))) + 1

      const res = await req.get('/physioReservation/queryPhysioSchedulingDayStatus', {
        deptId: sessionStorage.getItem('deptId'),
        doctorId: this.form.doctorId,
        dayNum: dayNum
      })
      if (res.code === 200) {
        this.physioSchedulingDayStatusList = res.data && res.data.filter(v => v.status !== 1) || []
      }
    },
    reservationDateChange() {
      this.sourceSchedulingList = []
      this.doctorList = []
      this.schedulingList = []
      this.form.appointmentEndTimeText = ''
      this.form.appointmentStartTimeText = ''
      this.form.schedulingItemVId = ''
      if (this.type == '0') {
        this.getScheduling()
      } else {
        this.form.doctorId = ''
        this.form.doctorName = ''
        this.getDoctorList()
      }
    },
    selectScheduling(item) {
      const scheduling = this.sourceSchedulingList.find(v => v.vId === item.vId)
      if (scheduling.disabled) {
        return false
      }
      this.form.schedulingItemVId = item.vId
      this.form.appointmentStartTimeText =  item.appointmentStartTimeText
      this.form.appointmentEndTimeText =  item.appointmentEndTimeText
    },
    async remoteProcutionList(name) {
      if (![null, undefined, ''].includes(name)) {
        const res = await getPhysioProcutions({ pageNum: 1, pageSize: 1000, physioName: name, searchMeiTuan: this.type == '1' ? 2 : 1 })
        if (res.code === 200) {
          this.productList = res.rows || []
        }
      } else {
        this.productList = []
      }
    },
    async getDoctorList() {
      if (this.form.spuIds.length > 0 && ![null, undefined, ''].includes(this.form.reservationDateTime)) {
        const res = await getPhysioTrilateralReservationScheduling({
          deptId: sessionStorage.getItem('deptId'),
          spuIds: this.form.spuIds,
          reservationDateTime: this.form.reservationDateTime
        })
        if (res.code === 200) {
          this.doctorList = res.data && res.data.map(v => {
            const info = {
              doctorId: v.doctor.doctorId,
              doctorName: v.doctor.doctorName,
              totalServerTime:v.totalServerTime,
              doctorImgAddr: v.doctor.doctorImgAddr,
              schedulingList: []
            }

            const schedulingList = v.reservationNoticeBoards && v.reservationNoticeBoards.map(scheduling => {
              scheduling['vId'] = this.generateUUID()
              scheduling['date'] = new Date(scheduling.appointmentStartDateTime).Format('yyyy-MM-dd')
              scheduling['appointmentStartDateTime'] = new Date(scheduling.appointmentStartDateTime).Format('yyyy-MM-dd hh:mm:ss')
              scheduling['appointmentEndDateTime'] = new Date(scheduling.appointmentEndDateTime).Format('yyyy-MM-dd hh:mm:ss')
              scheduling['appointmentStartTimeText'] = new Date(scheduling.appointmentStartDateTime).Format('hh:mm')
              scheduling['appointmentEndTimeText'] = new Date(scheduling.appointmentEndDateTime).Format('hh:mm')
              scheduling['timeTypeName'] = timeTypeMap[scheduling.timeType]
              scheduling['releaseStatus'] = new Date(scheduling.releaseTime).getTime() < new Date().getTime()
              scheduling['disabled'] = false
              scheduling['describe'] = '可约'
              switch (true) {
                case scheduling.status === '1':
                  scheduling.describe = '停诊'
                  scheduling.disabled = true
                  break
                case !scheduling.releaseStatus:
                  scheduling.describe = '未放号'
                  scheduling.disabled = true
                  break
                case new Date(scheduling.appointmentEndDateTime).getTime() < new Date().getTime():
                  scheduling.describe = '完诊'
                  scheduling.disabled = true
                  break
                case !scheduling.useReservation:
                  scheduling.describe = '约满'
                  scheduling.disabled = true
                  break
              }
              return scheduling
            }) || []

            info.schedulingList = schedulingList

            return info
          })
        }
      } else {
        this.doctorList = []
      }
    },
    generateUUID() {
      return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    selectDoctor(doctorId) {
      if (doctorId !== this.form.doctorId) {
        this.form.doctorId = doctorId
        this.form.schedulingItemVId = ''
        const doctor = this.doctorList.find(item => item.doctorId == doctorId)
        this.form.doctorName = doctor.doctorName
        this.sourceSchedulingList = doctor.schedulingList
        this.form.totalServerTime = doctor.totalServerTime
        this.schedulingList = doctor.schedulingList.reduce((res, cur) => {
          const resType = res.find(v => v.timeType === cur.timeType)
          if (resType) {
            resType.list.push(cur)
          } else {
            res.push({
              timeType: cur.timeType,
              timeTypeName: cur.timeTypeName,
              list: [cur]
            })
          }
          return res
        }, [])
      }
    },
    submit: debounce(async function () {
      this.confirmOrderMap.show = true
      // if (this.type == '0') {
      //   this.payRegister()
      // } else {

      // }
    }, 500, true),
    noPayRegister(toRedeem = false) {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          if (isNull(this.form.doctorId)) {
            this.$message.error('请选择执行人')
            return
          }
          if (isNull(this.form.schedulingItemVId)) {
            this.$message.error('请选择预约时段')
            return
          }
          const scheduling = this.sourceSchedulingList.find(v => v.vId === this.form.schedulingItemVId)
          if (scheduling) {
            this.loading = true
            const res = await postPhysioTrilateralReservation({
              deptId: sessionStorage.getItem('deptId'),
              patientId: this.form.patientId,
              spuIds: this.form.spuIds,
              doctorId: this.form.doctorId,
              schedulingItemId: scheduling.schedulingItemId,
              startTime: scheduling.appointmentStartDateTime,
              endTime: scheduling.appointmentEndDateTime,
              source: this.type == '1' ? 'trilateral' : 'platform-intermediary',
              plat: this.type == '2' ? 1 : null
            })
            this.loading = false
            if (res.code === 200) {
              this.$message.success('预约成功')
              this.close()
              this.confirmOrderMap.show = false
              if (toRedeem) {
                this.$emit('openRedeem', res.data, new Date(scheduling.appointmentStartDateTime).Format('yyyy-MM-dd') )
              }
            }
          }
        }
      })
    },
    payRegister() { 
      this.$refs['form'].validate(async valid => {
          if (valid) {
            if (isNull(this.form.schedulingItemVId)) {
              this.$message.error('请选择预约时段')
              return
            }
            const scheduling = this.sourceSchedulingList.find(v => v.vId === this.form.schedulingItemVId)
            if (scheduling) {
              this.loading = true
              const res = await  postPhysioReservation({
                deptId: sessionStorage.getItem('deptId'),
                orderNumber: this.orderNumber,
                physioIds: this.form.physioIds,
                doctorId: this.form.doctorId,
                schedulingItemId: scheduling.schedulingItemId,
                startTime: scheduling.appointmentStartDateTime,
                endTime: scheduling.appointmentEndDateTime,
                source: 'platform',
                orderId:this.orderId
              })
              this.loading = false
              if (res.code === 200) {
                this.$message.success('预约成功')
                this.close()
              }
            }
          }
        })
    },
    async queryReservationAppletCard() {
      let { code, data } = await queryReservationAppletCard({ patientId: this.form.patientId })
      if (code === 200) {
        data && data.forEach(v1 => {
          let product = []
          v1.reservationAppletPhysios && v1.reservationAppletPhysios.forEach(v2 => {
            product.push(v2.physioName)
          })
          v1.productText = product.join(',')
        })
        this.orderId = isEmptyArray(data) ? '' : data[0].orderId
        this.orderList = data || []
        this.selectOrder(this.orderId)
      }
    },
    selectOrder(id) {
      if (isNull(id)) return;
      this.orderId = id
      let obj = this.orderList.find(v => v.orderId === id)
      let physioIds = []
      let productSelectList = []
      obj.reservationAppletPhysios && obj.reservationAppletPhysios.forEach(v => {
        physioIds.push(v.physioId)
        productSelectList.push({
          spuId: v.spuId,
          physioId: v.physioId,
          physioName: v.physioName
        })
      })
      this.form.doctorId = ''
      this.form.reservationDateTime = ''
      this.form.schedulingItemVId = ''
      this.productList = obj.reservationAppletPhysios
      this.form.physioIds = physioIds
      this.productSelectList = productSelectList
    },
    typeChange() {
      this.form = {
        sex: '0',
        year: "",//岁
        month: '',//月份
        phone: '',
        physioIds: [],
        doctorId: '',
        reservationDateTime: '',
        schedulingItemVId: '',
        patientId: '',
        patientName: '',
        spuIds: [],
        totalServerTime:'',
        appointmentStartTimeText:'',
        appointmentEndTimeText:''
      }
      this.productSelectList = []
      this.orderId = ''
      this.productList = []
      this.orderList = []
      this.doctorList = []
    },
    addPatientComfirm(info) {
      this.$message.success('新增成功')
      this.patientList = [{
        patientId: info.patientId,
        patientName: info.patientName,
        phone: info.phone,
        sex: info.sex,
        age: info.age,
        ageMth: info.ageMth,
        birthday: info.birthday
      }]
      this.form.patientId = info.patientId
      this.form.patientName = info.patientName
      this.form.phone = info.phone
      this.form.year = info.age
      this.form.month = info.ageMth
      this.patientMap.addPatientDialog = false
      if (this.type == '0') {
        this.queryReservationAppletCard()
      }

    },
    addPatientClose() {
      this.patientMap.addPatientDialog = false
    },
    confirmOrder(){
      this.type == '0' ? this.payRegister() : this.noPayRegister()
    },
    confirmAndRedeem () {
      this.noPayRegister(true)
    }
  }
}
</script>

<style lang="less" scoped>
.mr4 {
  margin-right: 4px !important;
}

.mr8 {
  margin-right: 8px !important;
}
/deep/.el-empty__image{
  width: 44px;
}
.registerForm-warp {
  height: 600px;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .patient-warp {
    display: flex;
    margin-top: 24px;

    /deep/ .el-form-item__content {
      line-height: 32px;
    }

    /deep/ .el-input.is-disabled .el-input__inner {
      color: #1F2329;
    }

    .select-el-input__inner {
      border: 1px solid #DCDFE6 !important;
    }

    .el-input,
    .el-select {
      border: 1px solid #D3D3D5;
      border-radius: 2px;
      box-sizing: border-box;
    }

    /deep/ .el-input__inner {
      padding: 6px 6px;
      border: none;
      box-sizing: border-box;
    }


    /deep/ .el-input.is-disabled .el-input__inner {
      background: #fff;
    }

    .close-icon {
      position: absolute;
      top: 2px;
      right: 10px;
    }

    .edit-icon {
      position: absolute;
      top: 2px;
      right: 30px;
      font-size: 12px;
    }

    .el-form-item {
      margin-bottom: 0;

    }



    .name-select {
      width: 86px;

      /deep/ .el-input__suffix {
        display: none;
      }
    }

    .sex-select {
      width: 38px;

      /deep/ .el-input__inner {
        text-align: center;
      }

      /deep/.el-input__suffix {
        display: none;
      }
    }

    .year-input {
      width: 56px;
      position: relative;
    }

    .append {
      position: absolute;
      top: 0;
      right: 10px;
      color: #1F2329;
      font-size: 14px;
    }

    .phone-select {
      width: 146px;

      /deep/ .el-input__suffix {
        display: none;
      }
    }

    .add-btn {
      width: 32px;
      height: 35px;
      box-sizing: border-box;
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #D3D3D5;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .action-warp {
    flex: 1;
    overflow: auto;
    margin-top: 24px;

    .el-empty {
      padding-top: 120px;
    }

    .recipe-list {
      display: flex;
      gap: 8px;
      overflow-x: auto;
      padding-bottom: 4px;

      .recipe-item-active {
        border-color: #1890FF !important;
        background-color: #F4FAFF !important;
      }

      .recipe-item {
        width: 280px;
        padding: 12px;
        border-radius: 6px 6px 6px 6px;
        border: 1px solid #DDDFE0;
        box-sizing: border-box;
        flex-shrink: 0;

        .recipe-item-top {
          display: flex;
          align-items: center;
          .recipe-item-img {
            width: 44px;
            height: 44px;
            border-radius: 8px 8px 8px 8px;
            margin-right: 8px;
          }
        }

        .recipe-item-project {
          margin-top: 12px;
          color: #000;
          font-size: 14px;
          font-weight: 400;
          line-height: 18px;
        }

        .recipe-item-time {
          margin-top: 16px;
          text-align: right;
          font-weight: 400;
          font-size: 12px;
          color: #667182;
        }
      }
    }

    .dialog_form {
      overflow: hidden;
      margin-top: 24px;

      /deep/ .el-form-item__label {
        line-height: 32px;
        color: #333333;
      }

      /deep/ .el-form-item__content {
        line-height: 32px;
      }

      .form_checkbox_group {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
      }

      .form_checkbox {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 32px;
        overflow: hidden;
      }

      .form_input {
        width: 360px;
      }

      .form_item_doctor {
        margin: 0 0 0 0;
      }

      .form_item_times {
        margin: 0 0 0 0;
      }

      .doctor_list {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        margin: 4px -12px -12px 0;
        width: calc(100% + 12px);
        overflow: hidden;
      }

      .doctor_item {
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 12px 12px 0;
        padding: 0 12px;
        height: 50px;
        background-color: #FFFFFF;
        border: 1px solid #D5D5D5;
        border-radius: 6px;
        cursor: pointer;
      }

      .doctor_item.active {
        background-color: #FFF5EA;
        border-color: #E3874F;
      }

      .doctor_item_portrait {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        overflow: hidden;
        background-color: #FFFFFF;
      }

      .doctor_item_portrait_img {
        width: 100%;
        height: 100%;
      }

      .doctor_item_name {
        margin: 0 0 0 8px;
        font-size: 14px;
        color: #1F2329;
      }

      .scheduling {
        margin: 4px 0 0 0;
        width: 100%;
        overflow: hidden;
      }

      .scheduling_classes {
        width: 100%;
      }

      .scheduling_classes+.scheduling_classes {
        margin: 16px 0 0 0;
      }

      .scheduling_classes_name {
        line-height: 17px;
        font-size: 12px;
        color: #999999;
      }

      .scheduling_list {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        margin: 8px -12px -12px 0;
        width: calc(100% + 12px);
      }

      .scheduling_item {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 0 12px 12px 0;
        width: 141px;
        height: 50px;
        background-color: #FFFFFF;
        border: 1px solid #D5D5D5;
        border-radius: 6px;
        cursor: pointer;
      }

      .scheduling_item.active {
        background-color: #FFF5EA;
        border-color: #E3874F;
      }

      .scheduling_item.disabled {
        background-color: #EAE9E9;
        opacity: 0.4;
      }

      .scheduling_item_time {
        line-height: 20px;
        font-size: 14px;
        color: #1F2329;
      }

      .scheduling_item_status {
        line-height: 14px;
        font-size: 10px;
        color: #1F2329;
      }
    }
  }

  .dialog_footer {
    text-align: right;
  }
}

.confirmDialog {
  color: #000;
  font-size: 14px;
}

.confirmOrder_footer {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 12px 24px 16px 24px;
  width: 100%;
}

.dialog_redeem {
  color: #1890FF;
  border-color: #1890FF;
}
</style>